import styled from '@emotion/styled';

export const ButtonContiner = styled('div', { label: 'ButtonContiner' })`
    margin: 10px 0;
`;

export const ButtonContainer = styled('div', { label: 'ButtonContainer' })`
    margin-bottom: 10px;
`;

export const SuccessMessage = styled('div', { label: 'SuccessMessage' })`
    padding: 5px 10px;
    color: white;
    text-align: center;
    background-color: #3dcb35;
    border-radius: 3px;
    margin-bottom: 10px;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    padding: 5px 10px;
    color: #a94442;
    text-align: center;
    background-color: #f2dede;
    border-radius: 3px;
    margin-bottom: 10px;
`;
